
import { Question, isQuestionContent } from "@/types/test";

export const validateQuestion = (question: Question): boolean => {
  // Check if question content exists and has a question text
  if (!isQuestionContent(question.content) || !question.content.question?.trim()) {
    return false;
  }

  // Check if time limit is set and greater than 0
  if (!question.time_limit || question.time_limit <= 0) {
    return false;
  }

  // Check if marks is set and greater than 0
  if (!question.marks || question.marks <= 0) {
    return false;
  }

  // Check if markscheme exists with at least one criterion
  if (!question.markscheme || !question.markscheme.criteria || question.markscheme.criteria.length === 0) {
    return false;
  }

  // Check if at least one criterion has a name and description
  const hasValidCriterion = question.markscheme.criteria.some(
    criterion => criterion.name?.trim() && criterion.description?.trim()
  );

  return hasValidCriterion;
};

export const getValidationErrors = (question: Question): string[] => {
  const errors: string[] = [];

  if (!isQuestionContent(question.content) || !question.content.question?.trim()) {
    errors.push("Question text is required");
  }

  if (!question.time_limit || question.time_limit <= 0) {
    errors.push("Time limit must be set");
  }

  if (!question.marks || question.marks <= 0) {
    errors.push("Marks must be set");
  }

  if (!question.markscheme || !question.markscheme.criteria || question.markscheme.criteria.length === 0) {
    errors.push("Markscheme with criteria is required");
  } else {
    const hasValidCriterion = question.markscheme.criteria.some(
      criterion => criterion.name?.trim() && criterion.description?.trim()
    );
    if (!hasValidCriterion) {
      errors.push("At least one markscheme criterion must have name and description");
    }
  }

  return errors;
};
